import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import logo from '../../assets/logoAlternative.png'
import {
  BrowserRouter as Router,
  Link
} from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';

import InvertedHomeRightPane from './InvertedHomeRightPane'

import './header.css'

export default class Header extends Component {
  render() {
    return (
     <AppBar className={css(styles.appBar)} position="static" color="default">
      <Grid className="container" container>
        <Toolbar className={css(styles.noPadding)}>
        <Link style={{width: 'inherit'}} to="/">
    	   <img onClick={this.scrollToHeader} className={css(styles.logo)} src={logo} alt=""/>
        </Link>
          <Grid container alignItems="center" justify='flex-end'>
            <InvertedHomeRightPane />
          </Grid>
        </Toolbar>
      </Grid>
    </AppBar>
    );
  }
}
const styles = StyleSheet.create({
    appBar: {
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      boxShadow: 'none',
      position: 'fixed',
      width: '100%',
      top:'0', right: '0'
    },
    noPadding: {
      padding: '0',
      width: '100%'
    },
    logo: {
    	maxWidth: '170px',
    	padding: '.5em 0',
      cursor: 'pointer',
      ':hover': {
        opacity: .9
      }
    }
});


// WEBPACK FOOTER //
// ./src/Components/Header/InvertedHeader.js